import React from 'react';

interface HeaderIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export function LargeHeaderIcon({ width = 13, height = 13, className }: HeaderIconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 13 13" className={className} xmlns="http://www.w3.org/2000/svg">
      <path d="M2 2h9v2H2V2zm0 4h9v2H2V6zm0 4h9v2H2v-2z" fill="currentColor" />
    </svg>
  );
}
